// Copyright (c) 2026 Solartek LLC. All rights reserved.
import { z } from 'zod';
import { uuidSchema } from '../common.js';
export const searchQuerySchema = z.object({
    q: z.string().trim().min(1).max(100),
    types: z.string().max(100).optional(),
});
export const SEARCH_RESULT_TYPES = ['employee', 'device', 'branch', 'department'];
export const searchResultItemSchema = z.object({
    type: z.enum(SEARCH_RESULT_TYPES),
    id: uuidSchema,
    title: z.string(),
    subtitle: z.string().nullable(),
    branchId: uuidSchema.nullable(),
    status: z.string().nullable(),
});
export const searchResultSchema = z.object({
    q: z.string(),
    employees: z.array(searchResultItemSchema),
    devices: z.array(searchResultItemSchema),
    branches: z.array(searchResultItemSchema),
    departments: z.array(searchResultItemSchema),
});
//# sourceMappingURL=search-result.js.map